export const floorPlans = {
  '1dorm': {
    title: 'Garden com Pé Direito Duplo',
    area: '21,42m² a 22,98m²',
    specs: [
      { icon: 'ri-ruler-line', label: 'Área Privativa', value: '21,42m² a 22,98m²' },
      { icon: 'ri-arrow-up-down-line', label: 'Pé Direito', value: '5,30m livre (duplo)' },
      { icon: 'ri-hotel-bed-line', label: 'Tipologia', value: 'Garden' },
      { icon: 'ri-home-smile-line', label: 'Ambiente', value: 'Integrado' },
    ],
  },
  '2dorms': {
    title: 'Estúdios com Pé Direito Plex',
    area: '21,46m² a 23,81m²',
    specs: [
      { icon: 'ri-ruler-line', label: 'Área Privativa', value: '21,46m² a 23,81m²' },
      { icon: 'ri-arrow-up-down-line', label: 'Pé Direito', value: '4,10m livre (Plex)' },
      { icon: 'ri-hotel-bed-line', label: 'Tipologia', value: 'Estúdio' },
      { icon: 'ri-home-smile-line', label: 'Ambiente', value: 'Otimizado' },
    ],
  },
  '3dorms': {
    title: '1 Quarto com Pé Direito Plex',
    area: '30,17m²',
    specs: [
      { icon: 'ri-ruler-line', label: 'Área Privativa', value: '30,17m²' },
      { icon: 'ri-arrow-up-down-line', label: 'Pé Direito', value: '4,10m livre (Plex)' },
      { icon: 'ri-hotel-bed-line', label: 'Tipologia', value: '1 Quarto' },
      { icon: 'ri-home-smile-line', label: 'Ambiente', value: 'Funcional' },
    ],
  },
};
